export enum AuthQueryParamKey {
  COMPANY_ID = 'companyId',
  TOKEN = 'token',
  EMAIL = 'email',
  CONTINUE = 'continue',
}
